// "Production" enabled environment

export const environment = {
    production: true,
    hmr: false,
    appConfig: 'appconfig.devqa.json',
    docServerUrl: 'https://api.devqa.loomssoftware.com/onlyoffice'
};
